// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IdSearchField_wrapper__eDRvJ","close":"IdSearchField_close__1qBl7"};